import React from 'react';
import './InfrastructureCards.scss';
import Infra from './infraimages';

const InfrastructureOverview = () => {
  const paragraphText = `
    Our infrastructure includes a robust range of machinery assets such as Lathe (4Ft), Drilling machines, Bench Grinder, Surface Grinder, Vibro Barrelling, Projection Welding (CD & AC Types), Tapping Machines (M10–M18), and Chamfering Machines, totaling 10 units. 
    We operate 16 Power Presses with capacities ranging from 25T to 150T. 
    For precision work, we are equipped with digital measuring systems including Micrometre, Vernier, Height Gauge, and Dial Gauge. 
    Our workforce comprises 30 permanent and 20 contract employees, totaling 50 skilled personnel. 
    We utilize CATIA V5 R10 software for 3D tool design with a dedicated user license. 
    Our facility is powered with a capacity of 150 HP to support all operations efficiently.
  `;

  return (
    <div className="infrastructure-overview container py-5">
      <h2 className="section-title text-center mb-4">Infrastructure Overview</h2>

      <p className="lead text-justify px-3 mb-5">
        {paragraphText}
      </p>

      <hr className="my-5" />

      <h3 className="text-center mb-4">Infrastructure Gallery</h3>
      <div className="row g-4">
        {Infra.map((item) => (
          <div className="col-md-3 col-sm-3" key={item.id}>
            <div className="infra-image-card shadow-sm">
              <img src={item.imageUrl} alt={item.title} className="img-fluid rounded" />
              <div className="mt-2 text-center fw-semibold">{item.title}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfrastructureOverview;
